module.exports = __webpack_public_path__ + "static/media/Vector.2bbc78ea.webp";